import React, { memo, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Grid, Card } from '@material-ui/core';
import Form from '../Form';
import { FORM_NAME } from './config/constants';

const DiscountBlock = ({
    initializeForm,
    destroyForm,
    applyDiscount,
    classes,
    discountsEnabled,
}) => {
    useEffect(() => {
        initializeForm();
        return () => destroyForm();
    }, []);
    const handleSubmit = useCallback((values) => {
        if (typeof values.token !== 'undefined') {
            const { token } = values;
            applyDiscount(token);
        }
    }, []);

    if (!discountsEnabled) {
        return null;
    }

    return (
        <Grid justify="flex-end" container>
            <Grid xs={12} md={5} item>
                <Card className={classes.root}>
                    <Form
                        form={FORM_NAME}
                        onSubmit={handleSubmit}
                    />
                </Card>
            </Grid>
        </Grid>
    );
};

DiscountBlock.propTypes = {
    initializeForm: PropTypes.func.isRequired,
    destroyForm: PropTypes.func.isRequired,
    applyDiscount: PropTypes.func.isRequired,
    classes: PropTypes.shape({
        root: PropTypes.string.isRequired,
    }).isRequired,
    discountsEnabled: PropTypes.bool.isRequired,
};

export default memo(DiscountBlock);
